import { createSlice } from '@reduxjs/toolkit';
import { ReceivingsGridStateType } from 'src/types/receivingsGrid';

const initialState: ReceivingsGridStateType = {
    data: null,
    allProviders: false,
    loading: false,
    error: false,
};
export const receivingsGridSlice = createSlice({
    name: 'receivingsGrid',
    initialState,
    reducers: {
        getReceivingsGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            if (action.payload) {
                state.allProviders = action.payload.allProviders;
            }
        },
        getReceivingsGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getReceivingsGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getReceivingsGridFetch,
    getReceivingsGridFetchSuccess,
    getReceivingsGridFetchFailure,
} = receivingsGridSlice.actions;

export default receivingsGridSlice.reducer;
